import { apiClient } from "./apiClient";

export type AutoAcceptEnquiryScope = "LEGAL_ENTITY" | "BRANCH";

export interface AutoAcceptEnquiryConfig {
  id?: string;
  scope: AutoAcceptEnquiryScope;
  legalEntityId: string;
  /** Null for a legal-entity-wide config ("All Branches"). */
  branchId: string | null;
  enabled: boolean;
}

export const autoAcceptEnquiryService = {
  /**
   * Config for a scope, or `null` when nothing has been saved for it — the
   * endpoint answers 204 with an empty body in that case rather than 404, so an
   * absent config is a normal read and not an error the caller has to catch.
   */
  get: (params: {
    legalEntityId: string;
    branchId?: string | null;
  }): Promise<AutoAcceptEnquiryConfig | null> =>
    apiClient
      .get<AutoAcceptEnquiryConfig | "">("/auto-accept-enquiry", {
        params: {
          legalEntityId: params.legalEntityId,
          ...(params.branchId ? { branchId: params.branchId } : {}),
          skipGlobalContext: true,
        },
      })
      .then((response) =>
        response.status === 204 || !response.data ? null : (response.data as AutoAcceptEnquiryConfig),
      ),

  /** Upsert — the same POST creates the row or overwrites the one for this scope. */
  save: (payload: AutoAcceptEnquiryConfig): Promise<AutoAcceptEnquiryConfig> =>
    apiClient
      .post<AutoAcceptEnquiryConfig>("/auto-accept-enquiry", payload)
      .then((response) => response.data),
};
